import { createFileRoute } from '@tanstack/react-router';
import { taStaticData } from '../../talent-agency';

export const Route = createFileRoute('/_private-routes/talent-agency/$id/users')({
  staticData: taStaticData
});
